import { useEffect } from "react";
import ReactGA from "react-ga";

// Initialize Google Analytics with your tracking ID
ReactGA.initialize("G-GC94HDTH10");

// Create event tracking utility functions
export const trackEvent = (category, action, label = null) => {
  ReactGA.event({
    category,
    action,
    label,
  });
};

// Special handlers for different event types
export const trackProjectClick = (projectName) => {
  trackEvent("Project", "Click", projectName);
};

export const trackSocialMediaClick = (platform) => {
  trackEvent("Social Media", "Click", platform);
};

export const trackResumeClick = () => {
  trackEvent("Resume", "Download");
};

export const trackScrollDepth = (depth) => {
  trackEvent("Scroll", "Depth", `${depth}%`);
};

// Basic Analytics component that doesn't depend on Router
const Analytics = () => {
  // Track initial page view on component mount
  useEffect(() => {
    // Send pageview with current location
    ReactGA.pageview(window.location.pathname + window.location.search);

    // Add listener for browser history changes
    const handleLocationChange = () => {
      ReactGA.pageview(window.location.pathname + window.location.search);
    };

    // Listen for history changes
    window.addEventListener("popstate", handleLocationChange);

    // Clean up listener
    return () => {
      window.removeEventListener("popstate", handleLocationChange);
    };
  }, []);

  // Initialize scroll tracking
  useEffect(() => {
    let scrollDepths = [25, 50, 75, 100];
    let scrolledDepths = new Set();

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = Math.round((scrollTop / docHeight) * 100);

      scrollDepths.forEach((depth) => {
        if (scrollPercent >= depth && !scrolledDepths.has(depth)) {
          trackScrollDepth(depth);
          scrolledDepths.add(depth);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return null; // This component doesn't render anything
};

export default Analytics;
